/* ============================================================
   SUNTEX • assets/suntex-header.js
   ------------------------------------------------------------
   Minimal JS pour :
   - Burger mobile (open/close + body lock)
   - Accordéons sous-menus mobile
   - Toggle search overlay
   - Aria-expanded sync sur mega menu desktop (focus management)

   Pure vanilla, ~1.5 KB.
   ============================================================ */

(function () {
  'use strict';

  // ─── MOBILE MENU ───
  var burger = document.querySelector('[data-suntex-burger]');
  var mobileMenu = document.querySelector('[data-suntex-mobile-menu]');
  var mobileClose = document.querySelector('[data-suntex-mobile-close]');

  function openMobile() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('suntex-mobile-menu-open');
  }
  function closeMobile() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('suntex-mobile-menu-open');
  }

  if (burger) burger.addEventListener('click', function () {
    if (mobileMenu.classList.contains('is-open')) closeMobile(); else openMobile();
  });
  if (mobileClose) mobileClose.addEventListener('click', closeMobile);

  // Close on backdrop click
  document.addEventListener('click', function (e) {
    if (document.body.classList.contains('suntex-mobile-menu-open')) {
      if (e.target === document.body || e.target === document.documentElement) closeMobile();
    }
  });
  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMobile();
      var searchOverlay = document.querySelector('[data-suntex-search]');
      if (searchOverlay && !searchOverlay.hasAttribute('hidden')) toggleSearch(false);
    }
  });

  // ─── ACCORDÉONS MOBILES ───
  document.querySelectorAll('.suntex-mobile-menu__group-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub = btn.nextElementSibling;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (sub) sub.classList.toggle('is-open', !isOpen);
    });
  });

  // ─── SEARCH OVERLAY ───
  var searchToggle = document.querySelector('[data-suntex-search-toggle]');
  var searchOverlay = document.querySelector('[data-suntex-search]');
  var searchClose = document.querySelector('[data-suntex-search-close]');

  function toggleSearch(open) {
    if (!searchOverlay) return;
    if (open) {
      searchOverlay.removeAttribute('hidden');
      var input = searchOverlay.querySelector('input');
      if (input) setTimeout(function () { input.focus(); }, 50);
    } else {
      searchOverlay.setAttribute('hidden', '');
    }
  }
  if (searchToggle) searchToggle.addEventListener('click', function () {
    toggleSearch(searchOverlay.hasAttribute('hidden'));
  });
  if (searchClose) searchClose.addEventListener('click', function () { toggleSearch(false); });

  // ─── MEGA MENUS DESKTOP : open with delay close (fixes hover gap bug) ───
  var mqDesktop = window.matchMedia('(min-width: 980px)');

  document.querySelectorAll('.suntex-header__item--mega').forEach(function (item) {
    var trigger = item.querySelector('a[aria-haspopup="true"]');
    if (!trigger) return;

    var closeTimer = null;
    var CLOSE_DELAY = 200;  // ms — laisse le temps de traverser un éventuel gap

    function open() {
      if (!mqDesktop.matches) return;
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function close() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        closeTimer = null;
      }, CLOSE_DELAY);
    }

    function closeImmediate() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    // Souris : open au hover, close avec délai au mouseleave
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    // Si on rentre dans le mega menu, on annule le close timer
    var mega = item.querySelector('.suntex-mega');
    if (mega) {
      mega.addEventListener('mouseenter', open);
      mega.addEventListener('mouseleave', close);
    }

    // Clavier : focus-within
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) close();
    });

    // Click sur lien dans le mega menu → close après navigation
    item.querySelectorAll('.suntex-mega a').forEach(function (link) {
      link.addEventListener('click', closeImmediate);
    });

    item._suntexClose = closeImmediate;
  });

  // ─── Escape ferme tous les mega menus + le mobile menu + search ───
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.suntex-header__item--mega').forEach(function (item) {
        if (item._suntexClose) item._suntexClose();
      });
    }
  });

  // ─── Click outside ferme les mega menus ouverts ───
  document.addEventListener('click', function (e) {
    if (e.target.closest('.suntex-header')) return; // click inside header → ignore
    document.querySelectorAll('.suntex-header__item--mega.is-open').forEach(function (item) {
      if (item._suntexClose) item._suntexClose();
    });
  });

})();
